/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
const e="20231115",f="a6fcf2901ef678ef17a528e11b93ffe09e3ec267";export{e as buildDate,f as commitHash};
